import utils from './text_nodes.utils';

import type { PickRequired } from 'types/common_types';

export type TextNodeSliceIntialState = {
  activeNodeUid: string | null;
};

export type FontFamily = typeof utils.fontList[number];

export type TextAlignment = 'start' | 'middle' | 'end';

export type TextNodeEntity = {
  id: string;
  fontSize: string;
  fontFamily: FontFamily;
  textColor: string;
  horizontalAlignment: TextAlignment;
  verticalAlignment: TextAlignment;
  textContent: string;
  autofit: boolean;
};

export type TextNodeChangePayload = PickRequired<Partial<TextNodeEntity>, 'id'>;
export type TextNodeAutofitAdjustmentPayload = {
  id: string;
  adjustment: number;
};

/**
 * Measurement values of text lines within a text node's SVG container
 */
export type TextBounds = {
  top?: number;
  bottom?: number;
  width: number;
  height: number;
};
